import * as ng from 'angular';

import { Experience, ExperienceTypeDef } from '../';
import { FontService } from '../../../shared';
import { EditorPageModel } from './';

export interface EditorModel {
   init?():ng.IPromise<any>;
   addPage?(page:EditorPageModel);
   deletePage?(page:EditorPageModel);
   sortPage?(dragIndex:number, dropIndex:number);
   test?();
   previewUrl?:string;
   onSave?();

   /**
    * Optional set of extra experiences to create when this one is created.
    */
   siblings?:EditorModel[];
}

export abstract class EditorModel {
   // injected by model factory
   static $injector:ng.auto.IInjectorService;

   static $inject = ['fonts', '$q', '$rootScope'];

   inject(fontService:FontService, $q:ng.IQService, $rootScope:ng.IRootScopeService) {
      this.fontService = fontService;
      this.$q = $q;
      this.$rootScope = $rootScope;
   }

   fontService:FontService;
   $q:ng.IQService;
   $rootScope:ng.IRootScopeService;

   language:string;
   readonly isNew:boolean;
   dirty:boolean = false;

   hasPages:boolean = false;
   hasStaticPages = false;
   hasSetup:boolean = false;
   setupComplete:boolean = true;
   hasSettings:boolean = false;
   hasPreview:boolean = false;
   hasCode:boolean = false;
   showCode = false;
   defaultEditorPageIndex = 0;

   fonts:string[];

   private pristineSettings:any;
   private _experience:Experience;

   constructor(public campaign, public typeDef:ExperienceTypeDef, experience:Experience) {
      this.inject.$inject = EditorModel.$inject;
      EditorModel.$injector.invoke(this.inject, this);

      this.language = campaign.defaultLanguage;
      this.experience = experience;
      this.isNew = this.experience === null;
      this.fonts = this.fontService.fonts;

      this.$rootScope.$watch(
         () => this.experience.settings,
         () => this.onSettingsChange(),
         true // objectEquality
      );
   }

   get experience() {
      return this._experience;
   }

   set experience(experience:Experience) {
      this._experience = experience;
      this.pristineSettings = experience ? ng.copy(experience.settings) : null;
      this.dirty = false;
   }

   get languages():string[] {
      return this.campaign.settings.languages;
   }

   get settings() {
      return this.experience.settings;
   }

   get youtubeConnected():boolean {
      return !!this.campaign.settings.youTubeRefreshToken;
   }

   private onSettingsChange() {
      this.dirty = !ng.equals(this.experience.settings, this.pristineSettings);
   }

   abstract pages:EditorPageModel[];

   validate():ng.IPromise<void> {
      return this.$q.resolve();
   }
}
